import { render, staticRenderFns } from "./appealReviewFailed.vue?vue&type=template&id=7d771802&scoped=true"
import script from "./appealReviewFailed.vue?vue&type=script&lang=js"
export * from "./appealReviewFailed.vue?vue&type=script&lang=js"
import style0 from "./appealReviewFailed.vue?vue&type=style&index=0&id=7d771802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d771802",
  null
  
)

export default component.exports